import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getTemplate = params => common.requestRaw(apiUrl + 'Template', params, 'get');
export const addTemplate = params => common.requestRaw(apiUrl + 'Template', params, 'post');
export const updateTemplate = params => common.requestRaw(apiUrl + 'Template', params, 'put');
export const deleteTemplate = params => common.requestRaw(apiUrl + 'Template', params, 'delete');
export const copyTemplate = params => common.requestRaw(apiUrl + 'Template/Copy', params, 'post');
export const cancleAddTemplate = params => common.requestRaw(apiUrl + 'Template/InsertCancle', params, 'delete');
export const testTemplateReceived = params => common.requestRaw(apiUrl + 'Template/ReceiveTest', params, 'post');
// phishing
export const getPhishingTemplate = params => common.requestRaw(apiUrl + 'Template/Phishing', params, 'get');
export const savePhishingTemplate = params => common.requestRaw(apiUrl + 'Template/Phishing', params, 'put');
export const deletePhishingTemplate = params => common.requestRaw(apiUrl + 'Template/Phishing', params, 'delete');
export const copyPhishingTemplate = params => common.requestRaw(apiUrl + 'Template/PhishingCopy', params, 'post');

export const uploadExamTemplateBodyImage = formData => {
  return axios({
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: apiUrl + 'Template/UploadImage',
    data: formData
  })
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
};



// WEBPACK FOOTER //
// ./src/script/libs/templateLib.js